<template>
  <div class="teaching-score-modify">
    <div class="header">
      <NavBar :title="barTitle"
              border
              @back="hidePopover">
      </NavBar>
    </div>
    <div class="main">
      <div class="main-cont"
           v-loading="loading || committing"
           :element-loading-text="loadingText">
        <div v-if="scheduleScore" class="score-form">
          <el-form :model="formData" label-width="120px" size="mini">
            <el-form-item label="学生姓名">
              <span>{{ elective.trueName }}</span>
            </el-form-item>
            <el-form-item label="学号">
              <span>{{ elective.regNo }}</span>
            </el-form-item>
            <el-form-item label="班级">
              <span>{{ elective.clazz }}</span>
            </el-form-item>
            <el-form-item label="课程">
              <span>{{ elective.courseName }}</span>
            </el-form-item>
            <!-- <el-form-item label="是否补修">
              <span :class="elective.isSupply ? 'status-tag success-tag' : 'status-tag danger-tag'">
                {{ elective.isSupply ? '是' : '否'}}
              </span>
            </el-form-item>
            <el-form-item label="是否初修">
              <span :class="elective.isFirst ? 'status-tag success-tag' : 'status-tag danger-tag'">
                {{ elective.isFirst ? '是' : '否'}}
              </span>
            </el-form-item> -->
            <el-form-item label="成绩状态">
              <span :class="getScoreStatusClass(elective.scoreStatusCode)">
                {{ elective.scoreStatus }}
              </span>
            </el-form-item>
            <template v-if="hasUsualScore">
              <div class="score-section-title">平时成绩({{ usualScoreScale }}%)</div>
              <el-form-item label="平时成绩">
                <BizScorePicker
                  v-model="formData.scoreUsualLuru"
                  trigger="focus"
                  :score-grades="usualScoreGrades"
                  v-bind="scoreRule"
                  @on-input="val => onInputScore('scoreUsual', val)">
                  <template #default="{onInput, pretty, isFail, isErr}">
                    <el-input
                      v-model="formData.scoreUsualLuru"
                      :class="[{'is-fail': isFail}, {'is-err': isErr}]"
                      placeholder="请输入平时成绩"
                      size="mini"
                      @input="onInput"
                      @blur="pretty"></el-input>
                  </template>
                </BizScorePicker>
                <span class="score-display">(原成绩: {{ elective.scoreUsualLuru || '未录入' }})</span>
              </el-form-item>
            </template>
            <template v-if="hasExamScore">
              <div class="score-section-title">考试成绩({{ examScoreScale }}%)</div>
              <el-form-item label="考试成绩">
                <BizScorePicker
                  v-model="formData.scoreExamLuru"
                  trigger="focus"
                  :score-grades="examScoreGrades"
                  v-bind="scoreRule"
                  @on-input="val => onInputScore('scoreExam', val)">
                  <template #default="{onInput, pretty, isFail, isErr}">
                    <el-input
                      v-model="formData.scoreExamLuru"
                      :class="[{'is-fail': isFail}, {'is-err': isErr}]"
                      placeholder="请输入考试成绩"
                      size="mini"
                      @input="onInput"
                      @blur="pretty"></el-input>
                  </template>
                </BizScorePicker>
                <span class="score-display">(原成绩: {{ elective.scoreExamLuru || '未录入' }})</span>
              </el-form-item>
            </template>
            <template v-if="hasWorkScore">
              <div class="score-section-title">作业成绩({{ workScoreScale }}%)</div>
              <el-form-item label="作业成绩">
                <BizScorePicker
                  v-model="formData.scoreWorkLuru"
                  trigger="focus"
                  :score-grades="workScoreGrades"
                  v-bind="scoreRule"
                  @on-input="val => onInputScore('scoreWork', val)">
                  <template #default="{onInput, pretty, isFail, isErr}">
                    <el-input
                      v-model="formData.scoreWorkLuru"
                      :class="[{'is-fail': isFail}, {'is-err': isErr}]"
                      placeholder="请输入作业成绩"
                      size="mini"
                      @input="onInput"
                      @blur="pretty"></el-input>
                  </template>
                </BizScorePicker>
                <span class="score-display">(原成绩: {{ elective.scoreWorkLuru || '未录入' }})</span>
              </el-form-item>
            </template>
            <template v-if="hasReportScore">
              <div class="score-section-title">报告成绩({{ reportScoreScale }}%)</div>
              <el-form-item label="报告成绩">
                <BizScorePicker
                  v-model="formData.scoreReportLuru"
                  trigger="focus"
                  :score-grades="reportScoreGrades"
                  v-bind="scoreRule"
                  @on-input="val => onInputScore('scoreReport', val)">
                  <template #default="{onInput, pretty, isFail, isErr}">
                    <el-input
                      v-model="formData.scoreReportLuru"
                      :class="[{'is-fail': isFail}, {'is-err': isErr}]"
                      placeholder="请输入报告成绩"
                      size="mini"
                      @input="onInput"
                      @blur="pretty"></el-input>
                  </template>
                </BizScorePicker>
                <span class="score-display">(原成绩: {{ elective.scoreReportLuru || '未录入' }})</span>
              </el-form-item>
            </template>
            <template v-if="hasCaseScore">
              <div class="score-section-title">案例成绩({{ caseScoreScale }}%)</div>
              <el-form-item label="案例成绩">
                <BizScorePicker
                  v-model="formData.scoreCaseLuru"
                  trigger="focus"
                  :score-grades="caseScoreGrades"
                  v-bind="scoreRule"
                  @on-input="val => onInputScore('scoreCase', val)">
                  <template #default="{onInput, pretty, isFail, isErr}">
                    <el-input
                      v-model="formData.scoreCaseLuru"
                      :class="[{'is-fail': isFail}, {'is-err': isErr}]"
                      placeholder="请输入案例成绩"
                      size="mini"
                      @input="onInput"
                      @blur="pretty"></el-input>
                  </template>
                </BizScorePicker>
                <span class="score-display">(原成绩: {{ elective.scoreCaseLuru || '未录入' }})</span>
              </el-form-item>
            </template>
            <div class="score-section-title">综合成绩</div>
            <el-form-item label="综合成绩">
              <el-input v-model="formData.scoreMergeLuru" disabled placeholder="自动计算"></el-input>
              <span class="score-display">(原成绩: {{ elective.scoreMergeLuru || '未录入' }})</span>
            </el-form-item>
            <div class="score-section-title">成绩备注</div>
            <el-form-item label="成绩备注">
              <el-input v-model="formData.scoreNote"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入成绩备注信息"></el-input>
              <span class="score-display">(原备注: {{ elective.scoreNote || '无' }})</span>
            </el-form-item>
            <el-form-item>
              <div class="form-buttons">
                <el-button size="mini"
                           type="primary"
                           :disabled="committing"
                           @click="handleCommit">提交修改</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div v-else-if="!loading" class="no-data">
          <el-empty :description="errorMessage || '暂无数据'">
            <el-button type="primary" size="mini" @click="loadScoreData">重新加载</el-button>
          </el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '../../../../../../widgets/NavBar'
import BizScorePicker from '../../../../../../biz/picker/score'
import scoreGradeUtils from '../../../../../../../util/biz/scoreGradeUtils'
import scoreComputeUtils from '../../../../../../../util/biz/scoreComputeUtils'

export default {
  name: 'TeachingScoreModify',
  components: {
    NavBar,
    BizScorePicker
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      isReady: false,
      loading: false,
      committing: false,
      loadingText: '数据加载中，请稍等...',
      scheduleScore: null,
      elective: {},
      errorMessage: '',
      formData: {
        scoreUsualLuru: '',
        scoreUsualZh: null,
        scoreExamLuru: '',
        scoreExamZh: null,
        scoreWorkLuru: '',
        scoreWorkZh: null,
        scoreReportLuru: '',
        scoreReportZh: null,
        scoreCaseLuru: '',
        scoreCaseZh: null,
        scoreMergeLuru: '',
        scoreMergeZh: null,
        scoreNote: ''
      }
    }
  },
  computed: {
    barTitle () {
      if (this.rowData) {
        return `修改成绩 - ${this.rowData.peStudentByFkStudentId.trueName} - ${this.rowData.peStudentByFkStudentId.regNo}`
      }
      return '修改成绩'
    },
    usualScoreScale () {
      return this.scheduleScore ? this.scheduleScore.usualScoreScale || 0 : 0
    },
    examScoreScale () {
      return this.scheduleScore ? this.scheduleScore.examScoreScale || 0 : 0
    },
    workScoreScale () {
      return this.scheduleScore ? this.scheduleScore.workScoreScale || 0 : 0
    },
    reportScoreScale () {
      return this.scheduleScore ? this.scheduleScore.reportScoreScale || 0 : 0
    },
    caseScoreScale () {
      return this.scheduleScore ? this.scheduleScore.caseScoreScale || 0 : 0
    },
    hasUsualScore () {
      return this.usualScoreScale > 0
    },
    hasExamScore () {
      return this.examScoreScale > 0
    },
    hasWorkScore () {
      return this.workScoreScale > 0
    },
    hasReportScore () {
      return this.reportScoreScale > 0
    },
    hasCaseScore () {
      return this.caseScoreScale > 0
    },
    usualScoreGrades () {
      const scheduleScore = this.scheduleScore
      if (scheduleScore) {
        const usualScoreGrade = scheduleScore.usualScoreGrade
        if (usualScoreGrade) {
          return scoreGradeUtils.getMatched(scheduleScore.scoreGrades, usualScoreGrade)
        }
      }
      return null
    },
    examScoreGrades () {
      const scheduleScore = this.scheduleScore
      if (scheduleScore) {
        const examScoreGrade = scheduleScore.examScoreGrade
        if (examScoreGrade) {
          return scoreGradeUtils.getMatched(scheduleScore.scoreGrades, examScoreGrade)
        }
      }
      return null
    },
    workScoreGrades () {
      const scheduleScore = this.scheduleScore
      if (scheduleScore) {
        const workScoreGrade = scheduleScore.workScoreGrade
        if (workScoreGrade) {
          return scoreGradeUtils.getMatched(scheduleScore.scoreGrades, workScoreGrade)
        }
      }
      return null
    },
    reportScoreGrades () {
      const scheduleScore = this.scheduleScore
      if (scheduleScore) {
        const reportScoreGrade = scheduleScore.reportScoreGrade
        if (reportScoreGrade) {
          return scoreGradeUtils.getMatched(scheduleScore.scoreGrades, reportScoreGrade)
        }
      }
      return null
    },
    caseScoreGrades () {
      const scheduleScore = this.scheduleScore
      if (scheduleScore) {
        const caseScoreGrade = scheduleScore.caseScoreGrade
        if (caseScoreGrade) {
          return scoreGradeUtils.getMatched(scheduleScore.scoreGrades, caseScoreGrade)
        }
      }
      return null
    },
    finalScoreGrade () {
      const scheduleScore = this.scheduleScore
      if (scheduleScore) {
        const finalScoreGrade = scheduleScore.finalScoreGrade
        if (finalScoreGrade) {
          return scoreGradeUtils.getMatched(scheduleScore.scoreGrades, finalScoreGrade, true)
        }
      }
      return null
    },
    scoreRule () {
      const scheduleScore = this.scheduleScore
      if (scheduleScore) {
        return {
          usualScoreScale: scheduleScore.usualScoreScale,
          examScoreScale: scheduleScore.examScoreScale,
          workScoreScale: scheduleScore.workScoreScale,
          reportScoreScale: scheduleScore.reportScoreScale,
          caseScoreScale: scheduleScore.caseScoreScale,
          scoreExtras: scheduleScore.scoreExtras,
          scoreAlias: scheduleScore.scoreAlias,
          displayFraction: scheduleScore.displayFraction,
          minScore: scheduleScore.minScore,
          maxScore: scheduleScore.maxScore,
          passScore: scheduleScore.passScore
        }
      }
      return {}
    }
  },
  mounted () {
    // 首次打开时初始化数据
    if (this.visible) {
      this.loadScoreData()
    }
  },
  methods: {
    hidePopover () {
      this.$emit('hidePopover')
    },
    getScoreStatusClass (statusCode) {
      // 根据状态码返回不同类型的样式类
      switch (statusCode) {
        case '0': // 未录入
          return 'status-tag info-tag'
        case '1': // 已保存
          return 'status-tag warning-tag'
        case '2': // 已提交
          return 'status-tag primary-tag'
        case '3': // 已认定
          return 'status-tag success-tag'
        default:
          return 'status-tag info-tag'
      }
    },
    loadScoreData () {
      this.loading = true
      this.loadingText = '数据加载中，请稍等...'
      this.errorMessage = ''
      this.$ajax({
        url: '/workspace/manager/teaching/score/modify/queryStudentScore',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          if (response.data.responseCode === 'SUCCESS') {
            this.scheduleScore = response.data.scheduleScore
            this.elective = this.scheduleScore.elective || {}
            // 初始化表单数据
            this.formData.scoreUsualLuru = this.elective.scoreUsualLuru || ''
            this.formData.scoreUsualZh = this.elective.scoreUsualZh || null
            this.formData.scoreExamLuru = this.elective.scoreExamLuru || ''
            this.formData.scoreExamZh = this.elective.scoreExamZh || null
            this.formData.scoreWorkLuru = this.elective.scoreWorkLuru || ''
            this.formData.scoreWorkZh = this.elective.scoreWorkZh || null
            this.formData.scoreReportLuru = this.elective.scoreReportLuru || ''
            this.formData.scoreReportZh = this.elective.scoreReportZh || null
            this.formData.scoreCaseLuru = this.elective.scoreCaseLuru || ''
            this.formData.scoreCaseZh = this.elective.scoreCaseZh || null
            this.formData.scoreMergeLuru = this.elective.scoreMergeLuru || ''
            this.formData.scoreMergeZh = this.elective.scoreMergeZh || null
            this.formData.scoreNote = this.elective.scoreNote || ''
            this.calculateTotal()
            this.isReady = true
          } else {
            this.errorMessage = response.data.message || '获取成绩数据失败'
          }
        }
      }).catch(() => {
        this.errorMessage = '请求发送失败，请稍后重试'
      }).finally(() => {
        this.loading = false
      })
    },
    validateScoreForm () {
      const errors = []
      if (this.hasUsualScore && !this.formData.scoreUsualLuru) {
        errors.push('平时成绩不能为空')
      }
      if (this.hasExamScore && !this.formData.scoreExamLuru) {
        errors.push('考试成绩不能为空')
      }
      if (this.hasWorkScore && !this.formData.scoreWorkLuru) {
        errors.push('作业成绩不能为空')
      }
      if (this.hasReportScore && !this.formData.scoreReportLuru) {
        errors.push('报告成绩不能为空')
      }
      if (this.hasCaseScore && !this.formData.scoreCaseLuru) {
        errors.push('案例成绩不能为空')
      }
      return errors
    },
    calculateTotal () {
      if (!this.scheduleScore) return
      const formElective = {
        scoreUsualLuru: this.formData.scoreUsualLuru,
        scoreUsualZh: this.formData.scoreUsualZh,
        scoreExamLuru: this.formData.scoreExamLuru,
        scoreExamZh: this.formData.scoreExamZh,
        scoreWorkLuru: this.formData.scoreWorkLuru,
        scoreWorkZh: this.formData.scoreWorkZh,
        scoreReportLuru: this.formData.scoreReportLuru,
        scoreReportZh: this.formData.scoreReportZh,
        scoreCaseLuru: this.formData.scoreCaseLuru,
        scoreCaseZh: this.formData.scoreCaseZh
      }
      const result = scoreComputeUtils.scoreMerge(this.scoreRule, formElective, this.finalScoreGrade)
      if (result) {
        this.formData.scoreMergeLuru = result.mergeLuru
        this.formData.scoreMergeZh = result.mergeZh
      } else {
        this.formData.scoreMergeLuru = ''
        this.formData.scoreMergeZh = null
      }
    },
    handleCommit () {
      const errors = this.validateScoreForm()
      if (errors.length) {
        this.$message.warning(errors[0])
        return
      }
      this.$confirm('确定要提交修改后的成绩吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.submitScoreData()
      }).catch(() => {})
    },
    submitScoreData () {
      this.committing = true
      this.loadingText = '数据提交中，请稍等...'
      // 构建选课数据
      const elective = {
        id: this.elective.id,
        scoreUsual: this.formData.scoreUsualLuru,
        scoreUsualZh: this.formData.scoreUsualZh,
        scoreExam: this.formData.scoreExamLuru,
        scoreExamZh: this.formData.scoreExamZh,
        scoreWork: this.formData.scoreWorkLuru,
        scoreWorkZh: this.formData.scoreWorkZh,
        scoreReport: this.formData.scoreReportLuru,
        scoreReportZh: this.formData.scoreReportZh,
        scoreCase: this.formData.scoreCaseLuru,
        scoreCaseZh: this.formData.scoreCaseZh,
        scoreMerge: this.formData.scoreMergeLuru,
        scoreMergeZh: this.formData.scoreMergeZh,
        scoreNote: this.formData.scoreNote
      }
      this.$ajax({
        url: '/workspace/manager/teaching/score/modify/commitStudentScore',
        method: 'post',
        data: this.$qs.stringify({
          inputScore: JSON.stringify({
            electives: [elective]
          })
        })
      }).then(response => {
        if (response.data) {
          if (response.data.responseCode === 'SUCCESS') {
            // 使用框架的消息提示
            this.$message.success('成绩修改成功')
            this.$emit('hidePopoverAndRefresh')
          } else {
            this.$message.warning(response.data.message || '成绩修改失败')
          }
        }
      }).catch(() => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    onInputScore (fieldType, val) {
      this.$set(this.formData, `${fieldType}Zh`, val)
      this.calculateTotal()
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadScoreData()
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-modify {
    width: 600px;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      .extra {
        .el-button {
          padding: 6px 15px;
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
        padding: 20px;
        .score-form {
          width: 100%;
          max-width: 600px;
          margin: 0 auto;
          .score-section-title {
            padding: 10px 0;
            margin: 10px 0;
            font-weight: bold;
            color: #409EFF;
          }
          .score-display {
            margin-left: 10px;
            color: #909399;
            font-size: 12px;
          }
          .el-input {
            width: 180px;
          }
          .el-form-item {
            margin-bottom: 20px;
          }
          .form-buttons {
            text-align: center;
            margin-top: 10px;
          }
          .status-tag {
            padding: 4px 8px;
            font-size: 12px;
            border-radius: 2px;
          }
          .success-tag {
            color: #67C23A;
            background-color: #F0F9EB;
          }
          .danger-tag {
            color: #F56C6C;
            background-color: #FEF0F0;
          }
          .info-tag {
            color: #909399;
            background-color: #F4F4F5;
          }
          .warning-tag {
            color: #E6A23C;
            background-color: #FCF6EC;
          }
          .primary-tag {
            color: #337ab7;
            background-color: #ECF5FF;
          }
        }
        .no-data {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        }
      }
    }
  }
</style>
